import { useState } from 'react';
import { ToggleControlsHookInterface } from './types';

const useToggleControls: ToggleControlsHookInterface = (value = false) => {
  const [state, toggleState] = useState<boolean>(!!value);
  return [
    state,
    () => {
      toggleState(true);
    },
    () => {
      toggleState(false);
    },
    () => {
      toggleState((state) => !state);
    },
  ];
};

export default useToggleControls;
